import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.3.8_@opentelemetry+api@1.9.1_@playwright+test@1.61.1_@types+node@20.19.43_react-dom@1_nj3fdzl7msbgcgz3kfsj26n5gy/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["DocsMobileNav"] */ "/app/packages/frontend/components/docs/docs-mobile-nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DocsSidebar"] */ "/app/packages/frontend/components/docs/docs-sidebar.tsx");
